import { render, staticRenderFns } from "./SidebarTournament.vue?vue&type=template&id=e766f740"
import script from "./SidebarTournament.js?vue&type=script&lang=js&external"
export * from "./SidebarTournament.js?vue&type=script&lang=js&external"
import style0 from "./SidebarTournament.vue?vue&type=style&index=0&id=e766f740&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports